import isEmpty from 'lodash/isEmpty'
import { CatalogProduct } from 'utils/api/Products/CatalogProduct'

export const isProductOutOfStock = (catalogProduct: CatalogProduct) =>
  catalogProduct?.product?.stock_status === 'show_out_of_stock' &&
  catalogProduct?.product?.available_stock <= 0 &&
  isEmpty(catalogProduct?.catalog_variants)
